export const getOrderId = (id?: string | null) => {
  if (!id) return '';
  return id?.split('/').shift();
};
